declare global {

	interface Date {
		addDays(days: number): Date;

		isInvalidDate(): boolean;
	}
}

var datePolyfill = () => {
	Date.prototype.addDays = function (days: number): Date {
		let date: Date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	}

	Date.prototype.isInvalidDate = function (): boolean {
		return new Date(this).toString() === 'Invalid Date';
	}
}

var setupDatePolyFills = () => {
	datePolyfill();
}

export default setupDatePolyFills;